package core.io.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 20.09.22
 * Author : mariorosshirt
 */

@Serializable
data class TokenDTOIn(

    @SerialName("token")
    val mToken: String
)
